var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"m-scope-of-list"},_vm._l((_vm.values),function(v){return _c('li',{staticClass:"m-scope-of-list__item",class:{ 'm-scope-of-list__item--active': v.active }},[_vm._v(_vm._s(v.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }